module.exports = __webpack_public_path__ + "img/me-anim.4a3d1a04.png";